export default "/048cb1f2b29308e18768c65cfd51e426596a830c/ee9346a7a9322dc42520ebdf49402b79.svg";